import PrimaryButton from "../components/buttons/PrimaryButton";
import SecondaryButton from "../components/buttons/SecondaryButton";
import Accordion from "../components/Accordion";
import Hero from "../components/Hero";
import HeroImage from "../../assets/images/Home1.jpg";
import { ReactComponent as Favicon } from "../../assets/icons/favicon.svg";
import { ReactComponent as Checkicon } from "../../assets/icons/tick_icon 1.svg";
import "../../css/pages/landingPage.css";
import LandingPage2 from "../../assets/images/Home 2.jpg";
import LandingPage3 from "../../assets/images/Home 3.jpg";
import { ReactComponent as WealthManagementIcon } from "../../assets/icons/Icon_wealth management.svg";
import { ReactComponent as FinancialPlanningIcon } from "../../assets/icons/Icon_financial planning.svg";
import { ReactComponent as MortgageIcon } from "../../assets/icons/Icon_mortgages.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as SavingsInvestmentIcon } from "../../assets/icons/savings_investments.svg";
import { ReactComponent as ProtectionIcon } from "../../assets/icons/protection.svg";
import { ReactComponent as EquityReleaseIcon } from "../../assets/icons/equity_Release.svg";
import TestimonialsSlider from "../constants/testimonials";


const LandingPage = () => {
  const navigate = useNavigate();
  return (
    <div style={{ gap: "0px" }}>
      <Hero
        // title="Welcome to Merrick Platts Financial Services"
        // subtitle="Your trusted partner for financial success"
        backgroundImage={HeroImage}
      >
        <div className="hero-inner-content">
          <div className="content hero-childern-row">
            <Favicon className="hero-favicon" />
            Financial goals with clarity, confidence and care.
          </div>
          <h1>
            Welcome to Merrick Platts <br />
            <span className="highlight">Financial Services</span>
          </h1>
          <div className="content hero-childern-row">
            We provide personalised financial strategies, investment guidance
            and wealth management solutions tailored to your unique needs. Our
            team is dedicated to helping you plan for today and secure tomorrow.
          </div>
          {/* <div className="hero-buttons">
            <SecondaryButton text={"Speak to Us"} />
            <PrimaryButton text={"About Merrick"} />
          </div> */}
          <div className="hero-features">
            <div className="hero-feature">
              <Checkicon className="hero-feature-icon" />
              Tailored Financial Plans
            </div>
            <div className="hero-feature">
              <Checkicon className="hero-feature-icon" />
              Trusted Investment Advice
            </div>
            <div className="hero-feature">
              <Checkicon className="hero-feature-icon" />
              Transparent & Secure
            </div>
          </div>
        </div>
      </Hero>
      <div className="landing-page">
        <div className="light-row">
          <div className="column">
            <div className="content-semibold secondary">
              WELCOME TO MERRICK PLATTS FINANCIAL SERVICES
            </div>
            <div className="title-semibold primary">
              Financial advisory firm located in Leicestershire
            </div>
            <div className="divider align-left" />
            <div className="content-semibold primary">
              Our approach is to provide a bespoke service to all of our clients
              in a clear and cost effective way.
            </div>
            <div className="content primary">
              Our highly experienced adviser can provide you with a personal and
              professional service in your own home or office.
            </div>
            <div className="hero-buttons">
              <SecondaryButton
                text={"Speak to Us"}
                onClick={() => navigate("/contact-us")}
              />
              <PrimaryButton
                text={"About Merrick"}
                onClick={() => navigate("/about-us")}
              />
            </div>
          </div>
          <img
            src={LandingPage2}
            className="landing-page-image"
            alt="Landing Page 2"
          />
        </div>
      </div>
      <div className="primary-container">
        <div className="column align-center small-gap">
          <div className="content-semibold secondary">FINANCIAL SERVICES</div>
          <div className="content-semibold">
            We offer a full range of financial services tailored to your needs.
            Explore how we can help you below.
          </div>
          <div className="divider align-center" />
          <div className="light-row ">
            <div className="column align-center small-gap min-width">
              <WealthManagementIcon className="service-icon" />
              <div className="content-semibold">Wealth Management</div>
              <div className="content">
                Wealth, just like your health, must be carefully preserved.
                Whatever your level...
              </div>
              <SecondaryButton
                text={"Find out More"}
                onClick={() => navigate("/services/wealth-management")}
              />
            </div>
            <div className="column align-center small-gap min-width">
              <FinancialPlanningIcon className="service-icon" />
              <div className="content-semibold">Taxation</div>
              <div className="content">
                Proactive planning to minimise liabilities and maximise what you
                keep.
              </div>
              <SecondaryButton
                text={"Find out More"}
                onClick={() => navigate("/services/taxation")}
              />
            </div>
            <div className="column align-center small-gap min-width">
              <MortgageIcon className="service-icon" />
              <div className="content-semibold">Mortgages</div>
              <div className="content">
                Loans which are intended to help buyers purchase residential
                property...
              </div>
              <SecondaryButton
                text={"Find out More"}
                onClick={() => navigate("/services/mortgages")}
              />
            </div>
            {/* </div>
          <div className="light-row"> */}
            <div className="column align-center small-gap min-width">
              <SavingsInvestmentIcon className="service-icon" />
              <div className="content-semibold">Savings/Investments</div>
              <div className="content">
                Make your money work smarter with a structured plan to build and
                grow wealth.
              </div>
              <SecondaryButton
                text={"Find out More"}
                onClick={() => navigate("/services/savings-investments")}
              />
            </div>
            <div className="column align-center small-gap min-width">
              <ProtectionIcon className="service-icon" />
              <div className="content-semibold">Protection</div>
              <div className="content">
                Safeguard your finances and loved ones with protection against
                life’s uncertainties.
              </div>
              <SecondaryButton
                text={"Find out More"}
                onClick={() => navigate("/services/protection")}
              />
            </div>
            <div className="column align-center small-gap min-width">
              <EquityReleaseIcon className="service-icon" />
              <div className="content-semibold">Equity Release</div>
              <div className="content">
                Unlock your home’s value later in life for greater financial
                freedom without moving.
              </div>
              <SecondaryButton
                text={"Find out More"}
                onClick={() => navigate("/services/equity-release")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="landing-page">
        <div className="light-row">
          <img
            src={LandingPage3}
            className="landing-page-image"
            alt="Landing Page 3"
          />
          <div className="column">
            <div className="content-semibold secondary">HOW WE WORK</div>
            <div className="title-semibold primary">
              Here's how we formulate the plan towards your goals
            </div>
            <div className="divider align-left" />

            <div className="content primary">
              Many people have goals and dreams, but a goal without a plan is
              just a wish... an achievable goal is a dream with a deadline.
            </div>
            <div className="hero-buttons">
              <SecondaryButton
                text={"Speak to Us"}
                onClick={() => navigate("/contact-us")}
              />
              <PrimaryButton
                text={"About Merrick"}
                onClick={() => navigate("/about-us")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="primary-container">
        <div className="steps-container">
          <div className="step-card ">
            <div className="step-number">1</div>
            <div className="column small-gap align-center">
              <div className="subtitle-semibold primary">About You</div>
              <div className="content primary step-desc">
                We meet together to discuss your personal circumstances and your
                current financial situation.
              </div>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">2</div>
            <div className="column small-gap align-center">
              <div className="subtitle-semibold primary">
                Your Goals & Ambitions
              </div>
              <div className="content primary step-desc">
                Next we discuss your objectives and your aspirations, as well as
                any concerns that may arise.
              </div>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">3</div>
            <div className="column small-gap align-center">
              <div className="subtitle-semibold primary">Analysis</div>
              <div className="content primary step-desc">
                We'll discuss with you our analysis of your current financial
                position, and outline our initial thoughts for the plan.
              </div>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">4</div>
            <div className="column small-gap align-center">
              <div className="subtitle-semibold primary">How to get there</div>
              <div className="content primary step-desc">
                Now we know where you are and where you want to be. In this
                phase, we present your Personal Financial Plan.
              </div>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">5</div>
            <div className="column small-gap align-center">
              <div className="subtitle-semibold primary">Implementation</div>
              <div className="content primary step-desc">
                Implement the plan. Every course of action recommended and
                agreed with you is now put into motion.
              </div>
            </div>
          </div>
          <div className="step-card">
            <div className="step-number">6</div>
            <div className="column small-gap align-center">
              <div className="subtitle-semibold primary">Review the Plan</div>
              <div className="content primary step-desc">
                Review dates will be agreed and can take place annually or more
                regularly if required or requested
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="landing-page">
        <div className="light-row">
          <div className="column align-center">
            <div className="content-semibold secondary">TESTIMONIALS</div>
            <div className="content-semibold primary">
              What our clients say about us
            </div>
            <TestimonialsSlider />
            <div className="hero-buttons">
              <SecondaryButton
                text={"Speak to Us"}
                onClick={() => navigate("/contact-us")}
              />
              <PrimaryButton
                text={"About Merrick"}
                onClick={() => navigate("/about-us")}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <PrimaryButton text={"PButton"} />
      <SecondaryButton text={"SButton"} />
      <Accordion title="National Savings Products">
        The least risky of investment options are those offered by National
        Savings, which raises money on behalf of the UK Government. While
        investment returns are not exceptional and some involve tying your money
        up for long periods, they are nevertheless stable and in some cases can
        be paid tax free.
      </Accordion>
      <Accordion title="National Savings Products">
      </Accordion> */}
    </div>
  );
};

export default LandingPage;
